import classNames from 'classnames';

type VerticalDoctorShimmerProps = {
  className?: string;
};

const VerticalDoctorShimmer = ({ className }: VerticalDoctorShimmerProps) => {
  return (
    <div
      className={classNames(
        className,
        'w-[152px] h-[204px] max-h-[204px] shrink-0 flex flex-col rounded-lg border border-border-primary/20 bg-surface-primary overflow-hidden animate-pulse',
      )}
    >
      <div className="h-[78px] bg-surface-tertiary px-3 pt-2">
        <div className="flex justify-between">
          <div className="h-14 w-14 rounded-full bg-surface-secondary" />
          <div className="flex flex-col items-end gap-1">
            <div className="h-5 w-16 rounded-full bg-surface-secondary" />
            <div className="h-5 w-12 rounded-full bg-surface-secondary" />
          </div>
        </div>
      </div>

      <div className="flex min-h-0 flex-1 flex-col items-center px-3 pt-1">
        <div className="h-5 w-full rounded bg-surface-secondary" />
        <div className="mt-1 h-4 w-3/4 rounded bg-surface-tertiary" />
        <div className="mt-0.5 h-4 w-2/3 rounded bg-surface-tertiary" />
        <div className="mt-auto h-10 w-full rounded-full bg-surface-secondary" />
      </div>
    </div>
  );
};

export default VerticalDoctorShimmer;
